import React from 'react';

import { LegacyText, makeStyles, ViewModuleIcon } from '@gogame/components';

import { Container, Title } from './components';

const useStyles = makeStyles({
  icon: { fontSize: '60px' },
});
const HomeDashboardWelcome = () => {
  const classes = useStyles();
  return (
    <Container>
      <ViewModuleIcon color={'action'} className={classes.icon} />
      <Title variant={'h5'}>Start Building your Personal Dashboard!</Title>
      <LegacyText>
        Select your or public presets to quick view and analyze data
      </LegacyText>
    </Container>
  );
};

export default HomeDashboardWelcome;
